import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ type: "spring", stiffness: 100, damping: 15, delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <span className="text-xs uppercase tracking-[0.25em] font-bold text-sky-600">{children}</span>
);
